import React from 'react';
import styled from 'styled-components';

// Icon imports
import IconTodayUsers from '../../../assets/dashboard/Icono-Usuarios-Jugador.svg';
import IconMonthUsers from '../../../assets/dashboard/Icono-Usuarios-Jugador.svg';
import IconWeekGrowth from '../../../assets/dashboard/Icono-Esta-semana.svg';
import IconFreeUsers from '../../../assets/dashboard/Icono-Usuario-Gratis.svg';
import IconPaidUsers from '../../../assets/dashboard/Icono-Usuario-Pago.svg';

const iconMap = {
  today_users: IconTodayUsers,
  month_users: IconMonthUsers,
  week_growth: IconWeekGrowth,
  free_users: IconFreeUsers,
  paid_users: IconPaidUsers,
};

const KpiRow = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
  flex-wrap: wrap;
  background: #222;
  border-radius: 10px;
  padding: 12px 16px;
`;

const KpiItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding-right: 16px;
  border-right: 1px solid #3a3a3a;
  color: #fff;

  &:last-child {
    border-right: none;
  }

  .icon {
    width: 18px;
    height: 18px;
    object-fit: contain;
  }

  .value {
    font-size: 22px;
    font-weight: 700;
    color: ${props => props.valueColor || '#fff'};
    line-height: 1;
  }

  .desc {
    font-size: 12px;
    color: #9a9a9a;
    margin-left: 4px;
  }
`;

const KpiSection = ({ kpis = [] }) => {
  return (
    <KpiRow>
      {kpis.map((kpi) => (
        <KpiItem key={kpi.id} valueColor={kpi.valueColor}>
          <img
            src={iconMap[kpi.id] || IconTodayUsers}
            alt={kpi.label}
            className="icon"
          />
          <span className="value">{kpi.value}</span>
          <span className="desc">{kpi.label}</span>
        </KpiItem>
      ))}
    </KpiRow>
  );
};

export default KpiSection;

